export default __webpack_public_path__ + "static/media/Laskaris.889ecbb0.png";